/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_Generate_HintInputs */

const en_image_export_preview_generate_hint = /** @type {(inputs: Image_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click Generate Preview to see subtitle`)
};

const fr_image_export_preview_generate_hint = /** @type {(inputs: Image_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez sur Generer la previsualisation pour voir le sous-titre`)
};

const de_image_export_preview_generate_hint = /** @type {(inputs: Image_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klicken Sie auf „Vorschau generieren“, um die Untertitel anzuzeigen.`)
};

const it_image_export_preview_generate_hint = /** @type {(inputs: Image_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fare clic su Genera anteprima per vedere i sottotitoli`)
};

const ru_image_export_preview_generate_hint = /** @type {(inputs: Image_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нажмите «Создать предварительный просмотр», чтобы увидеть субтитры.`)
};

const es_image_export_preview_generate_hint = /** @type {(inputs: Image_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haga clic en Generar vista previa para ver los subtítulos.`)
};

const zh_cn2_image_export_preview_generate_hint = /** @type {(inputs: Image_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击“生成预览”查看字幕`)
};

const ja_image_export_preview_generate_hint = /** @type {(inputs: Image_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレビューを生成するをクリックすると字幕が表示されます`)
};

const hi_image_export_preview_generate_hint = /** @type {(inputs: Image_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक देखने के लिए पूर्वावलोकन उत्पन्न करें पर क्लिक करें`)
};

const pt_pt2_image_export_preview_generate_hint = /** @type {(inputs: Image_Export_Preview_Generate_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique em Gerar Pré-visualização para ver a legenda.`)
};

/**
* | output |
* | --- |
* | "Click Generate Preview to see subtitle" |
*
* @param {Image_Export_Preview_Generate_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_generate_hint = /** @type {((inputs?: Image_Export_Preview_Generate_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_Generate_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_preview_generate_hint(inputs)
	if (locale === "de") return de_image_export_preview_generate_hint(inputs)
	if (locale === "it") return it_image_export_preview_generate_hint(inputs)
	if (locale === "ru") return ru_image_export_preview_generate_hint(inputs)
	if (locale === "es") return es_image_export_preview_generate_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_preview_generate_hint(inputs)
	if (locale === "ja") return ja_image_export_preview_generate_hint(inputs)
	if (locale === "hi") return hi_image_export_preview_generate_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_preview_generate_hint(inputs)
	return en_image_export_preview_generate_hint(inputs)
});